import React from 'react';
import 'styles/nav-tab.scss';

const Tabs = ({tabs, className, onChange, active}) => (
  <ul className={`nav nav-tabs ${className || ''}`}>
    {tabs.map((tab) => (
      <li key={tab.value || tab.label} className="nav-item">
        <button
          type="button"
          className={`nav-link  ${
            active && active.label === tab.label ? 'active' : ''
          }`}
          onClick={() => {
            onChange(tab);
          }}
        >
          {tab.label}
        </button>
      </li>
    ))}
  </ul>
);

export default Tabs;
